import axios from "../../utils/axios";

// 获取信息
export function profile() {
    return axios({
        url: "/web/users/profiles",
        method: "GET",
        params: {}
    });
}

// 获取用户权限信息
export function usersProfiles() {
    return axios({
        url: "/web/authorities/users/profiles",
        method: "GET"
    });
}

export function login(account, password) {
    return axios({
        url: "/oauth/token",
        method: "POST",
        timeout: 60000,
        data: {
            clientId: "6002a5b47793a84cf9fa9dea",
            clientSecret: "f12405f464e85753c419d810fd2ab098",
            grantType: "mobile",
            scope: "all",
            mobile: account,
            password: password
        }
    });
}

export function logout(uid, token) {
    return axios({
        url: "/web/sign/out",
        method: "POST",
        data: { uid, token }
    });
}

export function password(data) {
    return axios({
        url: "/web/auth/login/password",
        method: "POST",
        data: data
    });
}
